import React from 'react'
import { Icon, useT } from '../../shared'
import ZoomLogo from '../../shared/ZoomLogo'

// `variant="favorite"`: butir ini dirender di grup Favorit, yaitu salinan butir
// aslinya. Atribut data-nav hanya dipasang di aslinya supaya satu id tidak muncul
// dua kali di DOM (pemilih tes dan skrip mencarinya lewat atribut itu).
export function NavItem({ item, active, rail, onNavigate, favorite = false, onToggleFavorite, variant }) {
  const t = useT()
  const go = () => onNavigate(item.id)
  const favLabel = `${favorite ? t.navFavRemove : t.navFavAdd}: ${item.label}`
  return (
    <div className="nav-row">
      <div
        data-nav={variant === 'favorite' ? undefined : item.id}
        className={"nav-item" + (active ? " active" : "")}
        role="link"
        tabIndex={0}
        aria-current={active ? 'page' : undefined}
        // Saat sidebar diciutkan label disembunyikan, jadi namanya pindah ke tooltip.
        title={rail ? `${item.label}${item.badgeHint ? ` · ${item.badgeHint}` : ''}` : undefined}
        aria-label={rail || item.badgeHint ? `${item.label}${item.badgeHint ? `, ${item.badgeHint}` : ''}` : undefined}
        onClick={go}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go() }
        }}
      >
        {/* Butir bermerek (mis. Zoom) memakai logonya sendiri, bukan ikon garis. */}
        <span className={"nav-icon-tile" + (item.brand ? " is-brand" : "")}>
          {item.brand === 'zoom'
            ? <ZoomLogo size={22} className="nav-icon" />
            : <Icon name={item.icon} size={16} className="nav-icon" />}
        </span>
        <span className="nav-label">{item.label}</span>
        {item.badge && <span className="nav-item-badge" title={item.badgeHint}>{item.badge}</span>}
        {/* Pada rail ikon angkanya disembunyikan; titik ini penggantinya. */}
        {item.badge && <span className="nav-badge-dot" aria-hidden="true" />}
      </div>
      {/* Saudara .nav-item, bukan anaknya: tombol di dalam role="link" tidak
          valid, dan klik bintang tidak boleh ikut memicu navigasi. */}
      {onToggleFavorite && !rail && (
        <button
          type="button"
          className={"nav-fav-btn" + (favorite ? " on" : "")}
          aria-pressed={favorite}
          aria-label={favLabel}
          title={favLabel}
          onClick={() => onToggleFavorite(item.id)}
        >
          <Icon name="star" size={13} style={favorite ? { fill: 'currentColor' } : undefined} />
        </button>
      )}
    </div>
  )
}

// Satu grup menu. Grup yang punya lebih dari satu butir dan berjudul bisa
// dilipat; selebihnya (butir tunggal, grup tanpa judul) tampil statis. Pada rail
// ikon judul disembunyikan, jadi semua butir selalu tampil.
export default function NavGroup({ group, page, rail, closed, onToggle, onNavigate, favs = [], onToggleFavorite }) {
  const collapsible = !!group.title && group.items.length > 1
  const expanded = !collapsible || rail || !closed
  const hasActive = group.items.some((item) => item.id === page)
  // Jumlah badge anggota ditampilkan di judul grup, supaya pekerjaan yang menunggu
  // terlihat sekilas dan tidak tersembunyi saat grup dilipat.
  const pending = group.variant === 'favorite'
    ? 0 // salinan butir yang sudah dihitung di grup aslinya
    : group.items.reduce((sum, item) => sum + (parseInt(item.badge, 10) || 0), 0)
  const bodyId = `nav-group-${group.key}`

  return (
    <div className="nav-section">
      {group.title && (collapsible ? (
        <button
          type="button"
          className={"nav-section-title nav-section-toggle" + (!expanded && hasActive ? " has-active" : "")}
          aria-expanded={expanded}
          aria-controls={bodyId}
          onClick={onToggle}
        >
          <span>{group.title}</span>
          {pending > 0 && (
            <span className="nav-item-badge nav-section-badge" title={`${pending}`}>{pending > 99 ? '99+' : pending}</span>
          )}
          <Icon name="chevron_down" size={12} className="nav-section-chevron" />
        </button>
      ) : (
        <div className="nav-section-title">{group.title}</div>
      ))}
      <div id={bodyId} className={"nav-group-body" + (expanded ? "" : " collapsed")}>
        <div className="nav-group-inner">
          {group.items.map((item) => (
            <NavItem
              key={item.id}
              item={item}
              active={page === item.id}
              rail={rail}
              onNavigate={onNavigate}
              favorite={favs.includes(item.id)}
              onToggleFavorite={onToggleFavorite}
              variant={group.variant}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
